import { FC } from "react";

import { useMultiStyleConfig } from "@chakra-ui/react";

import { Button } from "@components/buttons";

import { TOptionButtonProps } from "./types";
import getStyleOverrides from "./utils/getStyleOverrides";

const OptionButton: FC<TOptionButtonProps> = ({
  children,
  isSelected = false,
  width,
  height,
  minWidth,
  isDisabled = false,
  onClick,
  isFullWidth,
  name,
  sx,
  rightIcon,
  leftIcon,
  shouldWrap,
  id,
  testId,
}) => {
  const styles = useMultiStyleConfig("OptionButton", {});

  return (
    <Button
      id={id}
      data-testid={testId}
      fontWeight="normal"
      label={children}
      size="md"
      variant={isSelected ? "grey-light" : "transparent"}
      isDisabled={isDisabled}
      isOutlined={!isDisabled}
      onClick={onClick}
      type="button"
      name={name}
      rightIcon={rightIcon}
      leftIcon={leftIcon}
      shouldWrap={shouldWrap}
      sx={{
        ...styles.button,
        ...getStyleOverrides({ width, height, minWidth, isFullWidth }),
        /**
         * Make text underline disappear for leftIcon and rightIcon.
         * If span is inline, then it inherits it and we're unable to remove it.
         */
        "& > span": { d: "inline-block" },
        ...sx,
      }}
    />
  );
};

export default OptionButton;
